import React from "react";
import { ShieldCheck, Award, Star, Users2, AlertTriangle, Ban } from "lucide-react";

const BADGE_META = {
  "Verified Professional": { icon: ShieldCheck, cls: "bg-brand-light text-brand border-brand" },
  "Top Performer":         { icon: Award,       cls: "bg-amber-50 text-amber-700 border-amber-200" },
  "Highly Recommended":    { icon: Star,        cls: "bg-gold-50 text-gold-600 border-gold-200" },
  "Reliable Team":         { icon: Users2,      cls: "bg-gold-50 text-gold-600 border-gold-200" },
  "Under Review":          { icon: AlertTriangle, cls: "bg-amber-100 text-amber-800 border-amber-300" },
  "Removed":               { icon: Ban,         cls: "bg-red-50 text-red-700 border-red-200" },
};

/**
 * Renders quality badges as small pill chips.
 * - hideAdminOnly: hides badges that should only be visible to admin (Under Review, Removed).
 */
export default function QualityBadges({ badges, hideAdminOnly = false, size = "sm" }) {
  if (!badges || badges.length === 0) return null;
  const visible = badges.filter((b) => !(hideAdminOnly && (b === "Under Review" || b === "Removed")));
  if (visible.length === 0) return null;
  const px = size === "md" ? "px-3 py-1.5 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <div className="flex flex-wrap gap-1" data-testid="quality-badges">
      {visible.map((b) => {
        const meta = BADGE_META[b] || BADGE_META["Verified Professional"];
        const Icon = meta.icon;
        return (
          <span
            key={b}
            className={`inline-flex items-center gap-1 border rounded-full font-outfit font-bold uppercase tracking-widest ${meta.cls} ${px}`}
            data-testid={`badge-${b.replace(/\W+/g, "-").toLowerCase()}`}
          >
            <Icon className="w-3 h-3" strokeWidth={2.4} />
            {b}
          </span>
        );
      })}
    </div>
  );
}
